import { ContactUsActionTypes } from './contactUs.types'
import { API_CONSTANTS } from '../../utils/AppConstants'

const INITIAL_STATE = {
    contactUsSendMessageSuccess: null,
    contactUsSendMessageError: null,
    contactUsSendMessageReqStatus: '',
    contactUsMessageListSuccess: null,
    contactUsMessageListError: null
}

const contactUsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ContactUsActionTypes.CONTACT_US_SEND_MESSAGE_REQUEST_SUCCESS:
            return {
                ...state,
                contactUsSendMessageSuccess: action.payload,
                contactUsSendMessageError: null,
                contactUsSendMessageReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case ContactUsActionTypes.CONTACT_US_SEND_MESSAGE_REQUEST_ERROR:
            return {
                ...state,
                contactUsSendMessageSuccess: null,
                contactUsSendMessageError: action.payload,
                contactUsSendMessageReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case ContactUsActionTypes.CONTACT_US_SEND_MESSAGE_REQUEST_STATUS:
            return {
                ...state,
                contactUsSendMessageReqStatus: ''
            }
        case ContactUsActionTypes.CONTACT_US_MESSAGE_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                contactUsMessageListSuccess: action.payload,
                contactUsMessageListError: null
            }
        case ContactUsActionTypes.CONTACT_US_MESSAGE_LIST_REQUEST_ERROR:
            return {
                ...state,
                contactUsMessageListSuccess: null,
                contactUsMessageListError: action.payload
            }
        case ContactUsActionTypes.LOGOUT:
            return INITIAL_STATE
        default:
            return state
    }
}

export default contactUsReducer